<template>
    <div class="index-instruments-search">
        <div class="index-instruments-search__column _first">
            <div class="index-instruments-search__item _search">
                <div class="index-instruments-search__title">
                    Эффективный поиск рекламных площадок
                </div>
                <div class="index-instruments-search__image">
                    <WBImage src="/images/index-page/instruments/effective-search.png" />
                </div>
            </div>
            <div class="index-instruments-search__item _targeting">
                <div class="index-instruments-search__title">
                    Таргетинг на <span class="c-blue-600">нужную аудиторию</span>
                </div>
            </div>
        </div>
        <div class="index-instruments-search__column _second">
            <div class="index-instruments-search__item _base">
                <div class="index-instruments-search__title">
                    <span class="first-line">Эксклюзивная база из</span> <br />
                    <span class="c-blue-600 _big">7&nbsp;000&nbsp;000</span> <br />
                    проверенных блогеров, готовых работать на ваш успех!
                </div>
                <div class="index-instruments-search__image">
                    <WBImage src="/images/index-page/instruments/big-base.png" />
                </div>
            </div>
            <div class="index-instruments-search__start">
                Начать работу
                <WBIcon class="index-instruments-search__start-icon" name="arrow-right-long" />
            </div>
        </div>
        <div class="index-instruments-search__column _third">
            <div class="index-instruments-search__item _track">
                <div class="index-instruments-search__title">
                    Возможность отслеживать <span class="c-blue-600">рекламные стратегии конкурентов</span>
                </div>
            </div>
            <div class="index-instruments-search__item _roi">
                <div class="index-instruments-search__title">
                    Повышение ROI рекламных кампаний
                </div>
                <div class="index-instruments-search__image">
                    <picture>
                        <source media="max-width: 1279px" srcset="/images/index-page/instruments/roi-tablet.png" />
                        <WBImage src="/images/index-page/instruments/roi.png" />
                    </picture>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">

</script>

<style scoped lang="scss">
.index-instruments-search {
        $this: &;

        --item-padding-x: 40px;
        --item-padding-y: 48px;

        display: grid;
        grid-template-columns: 26.5625% 40.625% 29.6875%;
        gap: 20px;

        @include respond-to(tablet) {
            --item-padding-x: 24px;
            --item-padding-y: 32px;

            grid-template-columns: 1fr;
        }

        @include respond-to(mobile) {
            --item-padding-y: 32px;
        }

        &__column {
            display: flex;
            flex-flow: column;
            gap: 20px;

            @include respond-to(tablet) {
                flex-flow: row;

                @include respond-to(mobile) {
                    flex-flow: column;
                }
            }

            &._second {
                @include respond-to(tablet) {
                    flex-flow: column;
                    order: 3;
                }
            }
        }

        &__title {
            @include mulish23b;

            position: relative;
            z-index: 1;
            text-align: center;
            color: var(--grey-600);

            @include respond-to(tablet) {
                margin: 0 auto;
            }

            @include respond-to(mobile) {
                font-size: 20px;
                line-height: 1.2;
            }

            .first-line {
                @include mulish32b;

                @include respond-to(mobile) {
                    font-size: 24px;
                    line-height: 1;
                }
            }

            ._big {
                display: inline-flex;
                margin: 12px 0;
                font-family: var(--accent-font), sans-serif;
                font-size: 36px;
                font-weight: 700;
                line-height: 1;
                letter-spacing: 3px;
            }
        }

        &__image {
            position: relative;
            width: calc(100% + 2 * var(--item-padding-x));
            margin: 0 calc(var(--item-padding-x) * -1) calc(var(--item-padding-y) * -1);

            img {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                object-fit: cover;

                @include respond-to(tablet) {
                    top: auto;
                    bottom: 0;
                    left: 50%;
                    transform: translateX(-50%);
                }
            }
        }

        &__item {
            overflow: hidden;
            padding: var(--item-padding-y) var(--item-padding-x);
            border-radius: 32px;
            background-color: var(--white);

            @include respond-to(tablet) {
                width: 100%;
            }

            &._search {
                @include respond-to(tablet) {
                    background: linear-gradient(180deg, #FFF 55.35%, #C7CFE8 89.7%, #3B5469 91.85%, #35465E 105.83%, #AEB9DD 117.61%);
                }

                #{$this}__image {
                    height: 306px;
                    margin-top: -10px;

                    @include respond-to(tablet) {
                        height: 270px;
                        margin-top: -52px;
                    }

                    @include respond-to(mobile) {
                        margin-top: -40px;
                    }

                    img {
                        @include respond-to(tablet) {
                            max-width: 281px;
                            height: auto;
                        }
                    }
                }

                #{$this}__title {
                    @include respond-to(tablet) {
                        max-width: 294px;
                    }
                }
            }

            &._base {
                #{$this}__image {
                    height: 282px;
                    margin-top: -4.19px;

                    @include respond-to(tablet) {
                        height: 247px;
                        margin-top: 37px;
                    }

                    @include respond-to(mobile) {
                        margin-top: 12px;
                    }

                    img {
                        @include respond-to(tablet) {
                            max-width: 635px;
                        }
                    }
                }

                #{$this}__title {
                    @include respond-to(tablet) {
                        max-width: 404px;
                    }
                }
            }

            &._roi {
                @include respond-to(tablet) {
                    background: linear-gradient(179.88deg, #FFF 88.79%, #527487 89.13%, #7892A0 99.91%);
                }

                @include respond-to(mobile) {
                    order: -1;
                }

                #{$this}__image {
                    height: 326px;
                    margin-top: -30px;

                    @include respond-to(tablet) {
                        height: 253px;
                        margin-top: -49px;
                    }

                    img {
                        @include respond-to(tablet) {
                            max-width: 251px;
                            height: auto;
                        }
                    }
                }

                #{$this}__title {
                    @include respond-to(tablet) {
                        max-width: 310px;
                    }
                }
            }

            &._roi,
            &._search {
                height: 400px;

                @include respond-to(tablet) {
                    height: 300px;
                }
            }

            &._targeting {
                display: flex;
                align-items: center;
                flex-grow: 1;

                @include respond-to(mobile) {
                    padding: 40px;
                }

                #{$this}__title {
                    @include respond-to(mobile) {
                        max-width: 256px;
                    }
                }
            }

            &._targeting,
            &._track {
                height: 200px;
                max-height: 200px;

                @include respond-to(tablet) {
                    display: flex;
                    align-items: center;
                    flex-grow: 0;
                    width: 284px;
                    height: auto;
                    max-height: 100%;
                }

                @include respond-to(mobile) {
                    width: 100%;
                }
            }
        }

        &__start {
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            height: 120px;
            border-radius: 25px;
            background: linear-gradient(260.02deg, #1F5EF1 58.7%, #12168B 148.57%);
            color: var(--white);
            cursor: pointer;

            @include mulish24b;

            @include respond-to(tablet) {
                height: 76px;
                font-size: 24px;
                font-weight: 600;
            }

            @include respond-to(mobile) {
                @include mulish20b;
            }
        }

        &__start-icon {
            position: absolute;
            top: 50%;
            right: 40px;
            font-size: 44px;
            transform: translateY(-50%);

            @include respond-to(mobile) {
                font-size: 36px;
            }
        }
    }
</style>
